import download from 'downloadjs';
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import api from '../../../config.js';
import './balances.css';
import { viewItem, getParameter, showMessageError, objectToURLParams, keepJustValuesInOptionsList } from '../../../classes/functions';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { format } from 'date-fns';
import "../../../components/BasePage/Pagination/index.js";
import PaginationPage from '../../../components/BasePage/Pagination/index.js';
import Table from '../../../components/Table/index.js';
import "./labels.js";
import { tableBalances } from './labels.js';
import Select from "react-select";
import SelectSearchable from '../../../components/Select/SelectSearchable/index.js';
import MySelectSearchable from '../../../components/Select/MySelectSearchable/mySelectSearchable.js';
import { customStyleSelect } from '../../../classes/consts.js';

export default function Balances() {
  const [modalBalances, setModalBalances] = useState(false);
  const [modalFeaturesOpen, setModalFeaturesOpen] = useState(false);
  const [modalDetailsOpen, setModalDetailsOpen] = useState(false);
  const [feature, setFeature] = useState([]);
  const [qtdePage, setQtdePage] = useState(50);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [details, setDetails] = useState([]);
  const [filters, setFilters] = useState({
    armazem: [],
    pessoas: [],
    codigo_produto: [],
    cliente: [],
    produto: [],
    etiqueta_palete: "",
    lote: "",
    empresa: "",
    unidade_medida: "",
    saldo_reserva: "",
    endereco: []
  });
  const [sorting, setSorting] = useState({
    item: "CODIGO_PRODUTO",
    order: "DESC"
  });
  const [balances, setBalances] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState([]);
  const [people, setPeople] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [carrying, setCarrying] = useState(true);

  function getBalances() {
    api
      .get(`/api/balances/search?${objectToURLParams(filters)}&property=${sorting.item?.toLowerCase()}&sortingType=${sorting.order}&page=${page}&limit=${qtdePage}&usuario=${localStorage.usuario}`)
      .then((response) => {
        let labels = response.data.labels;
        let indexes = response.data.indexes;

        labels.push("Características");
        labels.push("Detalhes");

        indexes.push("caracteristicas");
        indexes.push("detalhes");

        setBalances(response.data.dados);
        setTotal(parseInt(response.data.total / qtdePage) + 1);
      }).catch((error) => {
        if (error?.response?.data) {
          showMessageError(error?.response?.data);
        }
      });
  }

  function getPeople() {
    return new Promise((resolve, reject) => {
      api
      .get("/api/people/getList")
      .then((response) => {
        let newPeopleArray = [];

        response.data.row.map((data) => {
          newPeopleArray.push({label: data.nome_fantasia, value: data.id?.toString()});
        });

        newPeopleArray.unshift({value: "", label: "Selecione"});

        setPeople(newPeopleArray);
      })
      .catch((error) => {
        console.log(error);
        showMessageError(error?.response?.data);
      })
      .finally(() => {
        resolve();
      });
    });
  }

  function getProducts(value = "", name) {
    return new Promise((resolve, reject) => {
      return api
      .get(`/api/products/getSearchProduct?term=${value || ""}`)
      .then((response) => {
        let newProductsArray = [];
        
        response.data.list.map((data, index) => {
          if(((value?.length <= 2) && index <= 50) || value.length > 2){
            newProductsArray.push({ label: `${data.codigo_produto} - ${data.descricao}`, value: data.id?.toString()});
          }
        });
  
        newProductsArray.unshift({ value: "", label: "Selecione" });
        
        setProducts(newProductsArray);
      })
      .catch((error) => {
        if (error?.response?.data) {
          showMessageError(error.response.data);
        }
      })
      .finally(() => {
        resolve();
      })
    });
  }

  function paramsToColumnsWithModals(item){
    const params = {produto: item.codigo_produto, empresa: localStorage.getItem("empresa"), produto: item.codigo_produto, armazem: item.armazem, endereco: item.endereco, lote: item.lote};

    if(item.etiqueta_palete){
      params.palete = item.etiqueta_palete;
    }

    if(item.cliente){
      params.cliente = item.cliente;
    }

    return objectToURLParams(params);
  }

  function getDataFeaturesByBalance(item) {
    api.get(`/api/balances/getDataFeaturesByBalance?${paramsToColumnsWithModals(item)}`)
      .then((response) => {
        setFeature(response.data.caracteristicas);
        setModalFeaturesOpen(true);
      }).catch((error) => {
        if (error?.response?.data) {
          showMessageError(error.response.data);
        }
      });
  }

  function getMacAndSerieNumbers(item){
    api
    .get(`/api/balances/getDetailsByBalance?${paramsToColumnsWithModals(item)}`)
    .then((response) => {
      setDetails(response.data);
      setModalDetailsOpen(true);
    })
    .catch((error) => {
      if (error?.response?.data){
        showMessageError(error.response.data);
      }
    });
  }

  function generatePrintWithCustomName(headers, data) {
    const content = headers['content-type'];
    const dateAndHour = new Date();
    const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');
    download(data, `controle de saldos ${formatedDateAndHour}.xlsx`, content)
  }

  function print() {
    const clientsValues = [];

    filters.pessoas.map((person) => {
      clientsValues.push(person.value);
    });

    const params = `cliente=${clientsValues}&produto=${filters.produto.value}&armazem=${filters.armazem}&endereco_de=${filters.endereco.value}&endereco_ate=${filters.endereco.value}&lote_de=${filters.lote_de}&lote_ate=${filters.lote_ate}&palete_de=${filters.palete_de}&palete_from=${filters.palete_ate}`;

    api.get(`api/balances/print?${params}`, { responseType: 'blob' })
      .then((response) => {
        generatePrintWithCustomName(response.headers, response.data);
      }).catch((error) => {
        if (error?.response?.data) {
          showMessageError(error.response.data);
        }
      });
  }

  function getWarehouses() {
    return new Promise((resolve, reject) => {
      api
      .get("/api/warehouses/getList")
      .then((response) => {
        let newWarehousesArray = [];
      
        response.data.map((data, index) => {
          newWarehousesArray.push({ label: data.descricao, value: data.id?.toString()});
        });
  
        newWarehousesArray.unshift({ value: "", label: "Selecione" });

        setWarehouses(newWarehousesArray);
      })
      .catch((error) => {
        console.log(error.response);
      })
      .finally(() => {
        resolve();
      });
    })
  }

  function getAddresses(value = ""){
    return new Promise((resolve, reject) => {
      api
      .get(`/api/adresses/searchAdresses?term=${value || ""}`)
      .then((response) => {
        let adaptedAddressesListForSelect = [{label: "Selecione", value: ""}]; 
    
        response.data.adresses.map((data, index) => {
          if((((value?.length <= 2) && index <= 50) || value.length > 2) && data.nome){
            return adaptedAddressesListForSelect.push({label: data.nome, value: data.id?.toString()});
          }
        });
    
        setAddresses(adaptedAddressesListForSelect);
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        resolve();
      });
    });
  }

  useEffect(() => {
    setCarrying(true);

    Promise.all([getWarehouses(), getPeople(), getAddresses(), getProducts()])
    .then(() => {
      setCarrying(false);
    });
  }, []);

  useEffect(() => {
    getBalances();
  }, [qtdePage, page])

  return (
    <div>
      <Header />
      <Division />
      <Lateral />
      <ReactTooltip />

      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Controle de Saldos">
          <button className="buttonInsertMargin" onClick={getBalances}>Pesquisar</button>
          {balances.length > 0 && <button className="buttonInsert" onClick={print}>Imprimir</button>}
          <select className='selectQtdeItens' value={qtdePage} onChange={(e) => setQtdePage(e.target.value)}>
            <option value="">Itens por página</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </Title>
        <div className="container">
          <div className="divGroup">
            <Table 
              tableName="balances"
              defaultTableValues={tableBalances}
              data={{state: balances, setState: setBalances}}
              sortingProperties={{state: sorting, setState: setSorting}}
              filters={{state: filters, setState: setFilters}}
              functions={
                [
                  {label: "Características", index: "caracteristicas", function: getDataFeaturesByBalance},
                  {label: "Detalhes", index: "detalhes", function: getMacAndSerieNumbers}
                ]
              }
              getList={getBalances}
              selects={[
                {index: "produto", options: products},
                {index: "endereco", options: addresses},
                {index: "armazem", options: warehouses},
                {index: "cliente", options: people}
              ]}
            ></Table>
          </div>
        </div>
        <br />
        <PaginationPage limit={total} page={page} setPage={setPage} />
      </div>}

      <Modal
        isOpen={modalFeaturesOpen}
        onRequestClose={() => setModalFeaturesOpen(false)}
        className="modal-content"
        contentLabel="Características"
        ariaHideApp={false}
        keepMounted
      >
        <div className="formDiv">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Característica</th>
                <th>Valor</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              {feature && feature.length > 0 && feature.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td data-label="Característica">{item.chave}</td>
                    <td data-label="Valor">{item.valor}</td>
                    <td data-label="Saldo">{item.saldo}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className="formDiv">
          <button type="button" className="buttonCancel" onClick={() => setModalFeaturesOpen(false)}>Fechar</button>
        </div>
      </Modal>

      <Modal
        isOpen={modalDetailsOpen}
        onRequestClose={() => setModalDetailsOpen(false)}
        className="modal-content"
        contentLabel="Detalhes"
        ariaHideApp={false}
        keepMounted
      >
        <div className="formDiv">
          <table>
            <thead>
              <tr>
                {details?.labels?.map((detailLabel, index) => {
                  return (
                    <th key={index}>{detailLabel}</th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {details?.data?.map((detailData, index)=> {
                  return(
                    <tr key={index}>
                      {details?.indexes?.map((label, i)=>{
                        return(
                          <td scope="col">{detailData[label]}</td>
                        )
                      })}
                    </tr>
                  )
              })}
              {details?.data?.length === 0 &&
                <tr>
                    <td colSpan={3}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="formDiv">
          <button type="button" className="buttonCancel" onClick={() => setModalDetailsOpen(false)}>Fechar</button>
        </div>
      </Modal>

      <Modal
        isOpen={modalBalances}
        onRequestClose={() => setModalBalances(false)}
        className="modal-content"
        contentLabel="Balances"
        ariaHideApp={false}
      >
        <div className="formDiv">
          <button type="button" className="buttonSubmit" onClick={() => setModalBalances(true)}>Imprimir</button>
          <button type="button" className="buttonCancel" onClick={() => setModalBalances(false)}>Fechar</button>
        </div>
      </Modal>
    </div>
  )
}